import { render } from "./ScheduleComparison.vue?vue&type=template&id=556879e5&scoped=true&bindings={}"
import script from "./ScheduleComparison.vue?vue&type=script&lang=ts"
export * from "./ScheduleComparison.vue?vue&type=script&lang=ts"

import "./ScheduleComparison.vue?vue&type=style&index=0&id=556879e5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-556879e5"

export default script